import { MockedRequest, ResponseResolver, restContext } from 'msw';
import { TempFileResponse } from '../../api/types/tempFile';

const uploadTempFile: ResponseResolver<
  MockedRequest,
  typeof restContext
> = async (req, res, ctx) => {
  const randInt = 1;

  if (randInt === 1) {
    return delayedResponse(
      ctx.status(201),
      ctx.json<TempFileResponse>({
        fileId: Math.floor(Math.random() * 999999 + 1),
      }),
    );
  } else if (randInt === 2) {
    // ファイルサイズが大きすぎる
    return delayedResponse(ctx.status(413));
  } else if (randInt === 3) {
    // その他エラー
    return delayedResponse(ctx.status(500));
  }
};

const mockTempFile = {
  uploadTempFile,
};
export default mockTempFile;
